const mutations = {
    GET_ACESSIBILIDADES(state, payload) {
        
        state.acessibilidade = payload;
    }
}

export default mutations